export const BLAST = 'Blast';
export const BASE = 'Base';
export const WORKFLOW = 'Workflow';
export const TRIGGERED = 'Triggered';

// CAMPAIGN is an amalgam of BLAST AND TRIGGERED
// currently only used with the /templates/data.json endpoint
// no other endpoint accepts this as a valid template type
export const CAMPAIGN = 'Campaign';

/**
 * Used in attach template takeover to determine which tab is selected
 *
 * Although these values are more representative of a "template source,"
 * they are referred to as templateType in the /templates/data.json endpoint
 *
 * @see https://github.com/Iterable/Iterable/blob/096ab06bace9bf72902bf6436d09b6408502b9f1/domain-api/src/main/scala/com/iterable/models/EmailTemplateType.scala
 */
export enum TemplateSource {
  Base = BASE, // equivalent to `Templates` in UI
  Campaign = CAMPAIGN, // equivalent to `Campaign content` in UI
  Workflow = WORKFLOW, // equivalent to `Journey content` in UI
}

/**
 * TemplateType is a union of all the possible template types
 * @see https://github.com/Iterable/iterable/blob/096ab06bace9bf72902bf6436d09b6408502b9f1/graphql/src/main/scala/com/iterable/services/graphqlserver/types/TemplateTypes.scala#L290-L308
 *
 * These values are only applicable for WhatsApp currently.
 *
 * Used in the /templates/data.json endpoint as a query parameter
 * named `whatsAppTemplateType` as `templateType` was already in use
 */
export enum TemplateType {
  UserInitiated = 'UserInitiated',
  BusinessInitiated = 'BusinessInitiated',
}
